/* unplugin-vue-components disabled */import { render } from "./ToggleComponent.vue?vue&type=template&id=73830b35&scoped=true"
import script from "./ToggleComponent.vue?vue&type=script&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&lang=js"

import "./ToggleComponent.vue?vue&type=style&index=0&id=73830b35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73830b35"]])

export default __exports__